import { Lightning, Router } from '@lightningjs/sdk'

import Button from '../components/button/button'
import SpeechComp from '../components/speechComp/speechComp'
import { black, getColor, grey300, grey920, white } from '../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../constants/fonts'
import { Images } from '../constants/paths'
import { AppConfig } from '../services/appConfig'
import { getText } from '../utils/dictionary'
import { getAsset } from '../utils/image'
import { captureScreenData, NON_BFF_SEGMENT_SCREENS } from '../utils/segmentAnalytics'

export default class ExitWindow extends SpeechComp {
  private _currentButton

  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey920),
      collision: true,
      flex: {
        direction: 'column',
      },
      Header: {
        w: (w) => w,
        h: 168,
        rect: true,
        color: getColor(black),
        Logo: {
          x: 73,
          y: 70,
          h: 29,
          w: 246,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.LOGO_LARGE), 256, 29),
        },
      },
      Container: {
        w: (w) => w,
        h: 912,
        y: 80,
        rect: true,
        color: getColor(grey920),
        flex: {
          direction: 'column',
          alignItems: 'center',
        },
        Title: {
          text: {
            text: getText('exitModalTitle'),
            fontSize: 48,
            lineHeight: 48,
            fontFace: UniNeueBold,
            textColor: getColor(white),
          },
          flexItem: {
            marginBottom: 16,
          },
        },
        Subtitle: {
          text: {
            text: getText('exitModalSubtitle'),
            fontSize: 40,
            lineHeight: 40,
            fontFace: UniNeueRegular,
            textColor: getColor(grey300),
          },
          flexItem: {
            marginBottom: 48,
          },
        },
        Buttons: {
          flex: {
            direction: 'column',
          },
          CancelButton: {
            w: 658,
            type: Button,
            label: getText('cancelButton'),
            flexItem: {
              marginBottom: 24,
            },
          },
          ExitButton: {
            w: 658,
            type: Button,
            label: getText('exit'),
          },
        },
      },
    }
  }

  get sectionText() {
    return (
      getText('exitModalTitle') +
      ' . . ' +
      getText('exitModalSubtitle') +
      ' . . 2 Options, scroll down to choose'
    )
  }

  get page() {
    return Router.getActivePage()
  }

  get cancelButton() {
    return this.tag('CancelButton') as Button
  }

  get exitButton() {
    return this.tag('ExitButton') as Button
  }

  _init() {
    this._currentButton = this.cancelButton
    this.exitButton.zIndex = this.zIndex + 1
    this.cancelButton.zIndex = this.zIndex + 1
  }

  _getFocused() {
    return this._currentButton
  }

  _focus() {
    this.visible = true
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.AppExit)
  }

  _handleLeft() {
    // Prevent modal from trying to focus up
  }

  _handleRight() {
    // Prevent modal from trying to focus down
  }

  _handleDown() {
    if (this._currentButton === this.cancelButton) {
      this._currentButton = this.exitButton
    }
  }

  _handleUp() {
    if (this._currentButton === this.exitButton) {
      this._currentButton = this.cancelButton
    }
  }

  _handleEnter() {
    if (this._currentButton === this.exitButton) {
      AppConfig.shared.onShutdown()
    } else if (this._currentButton === this.cancelButton) {
      this.refocusPage()
    }
  }

  _handleBack(event) {
    event.preventDefault()

    this.refocusPage()
  }

  _handleKey() {
    return true
  }

  _handleCursorHide() {
    // Allows capturing the event when the cursor disappears by being idle
    // triggering this modal's _getFocused() method
    this._refocus()
    this._currentButton?._focus()
  }

  refocusPage() {
    this.visible = false
    this._currentButton = this.cancelButton
    ;(this.page as any)._setState('Ready')
    Router.focusPage()
  }

  $updateFocusByHover(button) {
    this._currentButton = button
    this._refocus()
  }

  _handleClick(element) {
    if (element instanceof Button) {
      this._handleEnter()
    }
  }
}
